export const ID_OPTIONS = [
  { label: "list.voter_id", value: "voting" },
  { label: "list.rch_id", value: "rch" },
];
// Max Length as per Id Type
export const MAX_LENGTHS: any = {
  rch: 12,
  voting: 10,
  Samagra: 9,
  abha: 14,
  ssn: 9,
  nin: 9,
};
export const RELATION_OPTIONS = [
  { label: "list.father", value: "father" },
  { label: "list.mother", value: "mother" },
  { label: "list.brother", value: "brother" },
  { label: "list.sister", value: "sister" },
  { label: "list.husband", value: "husband" },
  { label: "list.wife", value: "wife" },
  { label: "list.friend", value: "friend" },
  { label: "list.son", value: "son" },
  { label: "list.daughter", value: "daughter" },
  { label: "list.other", value: "other" },
  { label: "list.self", value: "self" }, // do not change index of this option, as it getting used / removed in RELATION_OPTIONS_MINOR
];

/**
 * RELATION_OPTIONS_MINOR is a copy of RELATION_OPTIONS without the "self" option
 */
export const RELATION_OPTIONS_MINOR = RELATION_OPTIONS.slice(
  0,
  RELATION_OPTIONS.length - 1
);

console.log("RELATION_OPTIONS_MINOR", RELATION_OPTIONS_MINOR);

export const DISTRICT_OPTIONS = [
  { label: "Mumbai", value: "mumbai" },
  { label: "Thane", value: "thane" },
];

//Object modified to include id field which is required for Leyden Dropdown Component

const LANGUAGE_MAPPING: any = {
  en: "English",
  hi: "हिन्दी",
  gu: "ગુજરાતી",
  as: "অসমীয়া",
  kn: "ಕನ್ನಡ",
  te: "తెలుగు",
  mr: "मराठी",
  or: "ଓଡ଼ିଆ",
};

export const LANGUAGE_OPTIONS = process.env.REACT_APP_LANGAUAGES
  ? process.env.REACT_APP_LANGAUAGES.split(",").map((lang: any) => {
      return { label: LANGUAGE_MAPPING[lang], id: lang };
    })
  : [
      { label: "English", id: "en" },
      { label: "हिन्दी", id: "hi" },
    ];

export const stateLanguageList = [
  { stateName: "Gujarat", value: "gu", indexValue: "g" },
  { stateName: "Madhya Pradesh", value: "hi", indexValue: "h" },
  { stateName: "Rajasthan", value: "hi", indexValue: "h" },
  { stateName: "Uttar Pradesh", value: "hi", indexValue: "h" },
  { stateName: "Bihar", value: "hi", indexValue: "h" },
  { stateName: "Assam", value: "as", indexValue: "a" },
  { stateName: "Karnataka", value: "kn", indexValue: "k" },
  { stateName: "Andhra Pradesh", value: "te", indexValue: "t" },
  { stateName: "Maharashtra", value: "mr", indexValue: "m" },
  { stateName: "Odisha", value: "or", indexValue: "o" },
  { stateName: "Uttarakhand", value: "hi", indexValue: "h" },
];

export const loginActionMapper: any = {
  a: "asha_activate",
  default: "asha_login",
};

export const STATUS_LIST_ADMIN = [
  { label: "Active", value: "false" },
  { label: "Inactive", value: "true" },
];

export const SORT_LIST_ADMIN = [
  { label: "Recently Added", value: "created_at" },
];

export const SORT_LIST_BENIFICIARY = [
  { label: "ID (Beneficiary)", value: "identifier" },
  { label: "Districts", value: "address-district" },
  { label: "City", value: "address-city" },
  { label: "Recently Added", value: "_lastUpdated" },
];
